// 普通api
import Axios from './axios'
import {isNotEmpty} from "../tools/utils";

export default {
  addPostHeader(config) {
    return {
      ...config,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
    }
  },
  //logs
  logsGetList(query) {
    return Axios.get(`/apis/v1/users/logs/${query}`)
  },
  // 验证升级
  checkServiceState() {
    return Axios.get('/apis/user/source/updateprogram/')
  },


  getCaptcha() {
    return Axios.get("/v1/refresh_captcha")
  },
  login(user, config) {
    return Axios.post("/v1/token/", user, config)
  },
  deiLogin(params) {
    return Axios.get("/v1/edi/"+params)
  },

  getUserPreferenceCol(params){
    return Axios.get("/apis/v1/users/preference/"+params)
  },
  setUserPreferenceCol(params){
    if(isNotEmpty(params.id)){
      return Axios.patch(`/apis/v1/users/preference/${params.id}/`,params.params)
    }else{
      return Axios.post(`/apis/v1/users/preference/`,params.params)
    }
  },
}

